import { render, staticRenderFns } from "./OrdenCompraAddTableComponent.vue?vue&type=template&id=5bad5aa8&"
import script from "./OrdenCompraAddTableComponent.vue?vue&type=script&lang=js&"
export * from "./OrdenCompraAddTableComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports